/**
 * Created on 2017/2/19.
 * AccountBillsCtrl
 */
define('controllers/myaccount/bills/account-bills.ctrl',['app'], function (app) {
    app.controller('AccountBillsCtrl', ['$q', '$scope', '$state','UserInfo', '$location','OpenUp', 'payService','auiDialog',
        function ($q, $scope, $state, UserInfo, $location,OpenUp, payService, auiDialog) {

            /* 2. $scope变量声明 */
            var Model=$scope.Model=
                {
                    payAgreementType: {
                        0: 'PAYSVICEPROXY',
                        1: 'PAYSVICE'},
                    tabUrls : ['bills-settlement', 'bills-dispute'],
                    tabs:[
                        {srf: 'MyAccount.bills.settlement', title:("结算单")},
                        {srf: 'MyAccount.bills.dispute', title:("争议处理")}
                    ]
                };

            /* 3. $scope函数挂载 */
            $scope.goToHuaweiCloud = function () {
                auiDialog.confirm("您将跳转到华为云系统查询账单，请确认是否跳转？",function () {
                    AUI.BaseJSUtil.redirectUrlByBlank(Model.huaweiCloudUrl);
                });
            };


            /* 4. 初始化函数声明与执行 */

             !function () {

                 // 账单菜单的显示要查custumerCode,没有就不显示
                 payService.isPayable().then(function (payable) {
                     if (!payable) {
                         $state.go("home");
                     }else{
                         var parsedURI = $location.url().split('/')[3];
                         Model.selectedTab = Model.tabUrls.indexOf(parsedURI);
                     }
                 });

                 // 获取华为云用户状态，hwcloudRealname 2 表示华为云完成认证，新增华为云tab
                 UserInfo.getUserInfo().then(function (user) {
                     if (user.hwcloudRealname == 2) {
                         Model.isHuaweiCloudUser = true;
                         Model.huaweiCloudUrl = sysUrlCfg.huaweiCloud.huaweiCloudUrl;
                     }
                 });
             }();

        }])
});

